import React from "react";
import "./App.css";
import { Switch, Route } from "react-router-dom";
import MainHomepage from "./features/Homepage/MainHomepage";
import Homepage from "./features/Homepage/Course/Homepage";
import Contact from "./features/Homepage/Course/Contact";
import Register from "./features/Homepage/Course/Register/Register";
import SignIn from "./features/Homepage/Course/SignIn";
import Login from "./features/Homepage/Course/Login";
import UserInformation from "./features/Homepage/Admin/UserInformation";
import ListOfStudents from "./features/Homepage/Admin/ListOfStudents";
import AddAdmin from "./features/Homepage/Admin/AddAdmin";
import SelectAllAdmin from "./features/Homepage/Admin/SelectAllAdmin";
import CVpdf from "./features/Homepage/Details/CVpdf";
function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/userinformation">
          <UserInformation />
        </Route>
        <Route exact path="/">
          <MainHomepage />
        </Route>
        <Route path="/coursehomepage">
          <Homepage />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
        <Route path="/signIn">
          <SignIn />
        </Route>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/cvpdf">
          <CVpdf />
        </Route>
        {/*************************** */}
        <Route path="/listofstudent">
          <ListOfStudents />
        </Route>
        <Route path="/addadmin">
          <AddAdmin />
        </Route>
        <Route path="/selectalladmin">
          <SelectAllAdmin />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
